import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import Reviews from "../pages/reviews/page";
import NewConstruction from "../pages/services/new-construction/page";
import ResidentialRepair from "../pages/services/residential-repair/page";
import Generators from "../pages/services/generators/page";
import EVChargers from "../pages/services/ev-chargers/page";
import SolarPanel from "../pages/services/solar-panel/page";
import SpecialtyLighting from "../pages/services/specialty-lighting/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/reviews",
    element: <Reviews />,
  },
  {
    path: "/services/new-construction",
    element: <NewConstruction />,
  },
  {
    path: "/services/residential-repair",
    element: <ResidentialRepair />,
  },
  {
    path: "/services/generators",
    element: <Generators />,
  },
  {
    path: "/services/ev-chargers",
    element: <EVChargers />,
  },
  {
    path: "/services/solar-panel",
    element: <SolarPanel />,
  },
  {
    path: "/services/specialty-lighting",
    element: <SpecialtyLighting />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
